import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'



class Contact extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.i = 0


    this.ref = {
     
      form: null,
      container: null

    }

  }

  mount() {


    this.ref.form.addEventListener("submit", this.handleSubmit.bind(this));


    
}

handleSubmit(event){
  event.preventDefault();



  const myForm = this.ref.form;
  const formData = new FormData(myForm);

  this.ref.container.classList.add('is-sending')

  fetch("/", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams(formData).toString(),
    })
    .then((e) => this.formsent(e))
    .catch((error) => this.error(error));
};

formsent(e){
  if(e.ok) {
    this.ref.form.reset();
    this.ref.container.classList.remove('is-sending')
    this.ref.container.classList.add('is-sent')
  }
  else {
    this.error('Email failed to send')
   
  }
  
}

error(error) {
  this.ref.container.classList.add('is-error')
   this.ref.container.classList.remove('is-sending')
   
}

  unmount() {




  }


}

module.exports = Contact
